<template>
  <span class="locale-field-button-wrapper">
    <a-button
      :disabled="disabled"
      :class="hasLocale ? 'i18n-ok' : 'i18n-missing'"
      @click="openLocale"
    >
      国际化
    </a-button>
    <locale-field ref="localeField" @localeChange="onLocaleChange" />
  </span>
</template>

<script>
import LocaleField from '@/components/locale/LocaleField.vue'

export default {
  name: 'LocaleFieldButton',
  components: { LocaleField },
  props: {
    value: {
      type: Array,
      required: false
    },
    tableName: {
      type: String,
      required: true
    },
    inputType: {
      type: String,
      default: 'input',
      required: true
    },
    tableField: {
      type: String,
      required: true
    },
    fieldValue: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasLocale() {
      return Array.isArray(this.value) && this.value.length > 0
    }
  },
  methods: {
    openLocale() {
      const existingList = Array.isArray(this.value) ? this.value : []
      this.$refs.localeField && this.$refs.localeField.showLocaleField(this.inputType,this.tableName, this.tableField, this.fieldValue, existingList)
    },
    onLocaleChange(list) {
      this.$emit('input', Array.isArray(list) ? list : [])
    }
  }
}
</script>

<style>
.i18n-ok {
  background-color: #52c41a;
  border-color: #52c41a;
  color: #fff;
}
.i18n-missing {
  background-color: #ff4d4f;
  border-color: #ff4d4f;
  color: #fff;
}
.ant-input-suffix-button {
  right: -2px;
  position: absolute !important;
}
</style>


